// src/components/Intro.js
import React from 'react';

function IntroSection() {

  
    return (
        <div className = "mt-5 container">
        <p>
        The first Changemakers project this year introduced students to the importance of change advocacy, which focuses on educating themselves and informing others. The students tackled the question “How do the decisions I make as a consumer impact others?”  
     
       Each group selected a common household product, investigated the product from a variety of perspectives (critical thinking), then used Photoshop to create a digital collage that communicated key information about their research perspective (communication). </p>
       <p>While each image was individually designed, groups were challenged to make their images consistent, as though constructed by a single artist (collaboration). Finally, students inserted their research into the Photoshop designs to create an interactive graphic that, when viewed together, tells the story of their product (critical thinking, communication). 
  </p>
  <p>
    Each group's set of images are shown together. You can click on an image to view the full size interactive graphic for each student.<br></br>

    If a student's image does not show up, you can still click into the bordered rectangle to view the interactive graphic. 
  </p>
        </div>
    );
  }
  
  export default IntroSection;
  